import { InputValidate, isEmpty } from 'utils'

import { defaultFrequencyInputs, RepeatType } from './constants'

export const validateFrequencyData = (data: any, notRequiredFields: string[] = [], showTime = false) => {
  let hasError = false

  const frequencyInputs = defaultFrequencyInputs()
  Object.keys(frequencyInputs).map((key) => {
    if (!data.repeatType || data.repeatType === RepeatType.NoRepeat) return
    if (notRequiredFields.includes(key)) return
    if (!showTime && ['hour', 'minute'].includes(key)) frequencyInputs[key].required = false
    frequencyInputs[key].error = InputValidate({ ...frequencyInputs[key], value: data[key] })
    if (frequencyInputs[key].error?.length) hasError = true
  })
  const customOptionKeys = []
  const { custom, intervalUnit } = data
  if (intervalUnit === 'week') {
    customOptionKeys.push('weekDays')
  } else if (intervalUnit === 'month') {
    customOptionKeys.push('monthType')
    if (custom?.monthType === 'date') customOptionKeys.push('dateOfMonth')
    else customOptionKeys.push('weekOrdOfMonth', 'weekDayOfMonth')
  } else if (intervalUnit === 'year') {
    customOptionKeys.push('yearType')
    if (custom?.yearType === 'date') customOptionKeys.push('monthOfDateYear', 'dateOfDateYear')
    else customOptionKeys.push('weekOrdOfYear', 'weekOrdOfYear', 'monthOfDayYear')
  }

  customOptionKeys.map((key) => {
    if (!custom || isEmpty(custom[key])) hasError = true
  })

  return hasError
}
